import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

import ASSETS from '../../../assets';
import { shortenString } from '../../../utils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const Transaction = ({ transaction }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/transactions/${transaction?.TransferObj?.hash}`);
  };
  return (
    <div
      className='py-[14px] px-4 flex items-center gap-20 hover:bg-hover cursor-pointer border-b border-b-bryt-grey-200 last-of-type:border-b-0'
      onClick={handleNavigate}
    >
      <div className='flex items-center gap-2'>
        <div className='h-12 w-12 rounded-lg grid place-items-center bg-bryt-grey-100'>
          <img src={ASSETS.transaction} alt='' />
        </div>
        <div>
          <p className='text-[14.5px] text-bryt-primary-main w-[12ch] overflow-hidden text-ellipsis'>
            {transaction?.TransferObj?.hash || 'GENESIS_TRANSACTION'}
          </p>
          <p className='text-[14.5px] text-bryt-grey-700'>
            {dayjs.utc(transaction?.transaction_time).fromNow()}
          </p>
        </div>
      </div>
      <div className='flex-grow flex items-center justify-between gap-2'>
        <div>
          <p className='text-[14.5px]'>
            From{' '}
            <span className='text-bryt-primary-main'>
              {shortenString(transaction?.TransferObj?.from)}
            </span>
          </p>
          <p className='text-[14.5px]'>
            To{' '}
            <span className='text-bryt-primary-main'>
              {shortenString(transaction?.TransferObj?.to)}
            </span>
          </p>
        </div>
        <div className=' px-[9px] py-[7px] border border-bryt-grey-300 rounded-[6px]'>
          <p className='text-[11px] font-semibold'>
            {transaction?.TransferObj?.value} RYT
          </p>
        </div>
      </div>
    </div>
  );
};

const Transactions = () => {
  const { transactions } = useSelector(state => state.transactions);
  const [txs, setTxs] = useState([]);

  useEffect(() => {
    const txList = [...transactions];
    if (txList.length > 7) {
      const t = txList.reverse();
      setTxs(t.splice(0, 7));
    } else {
      const t = txList.reverse();
      setTxs(t);
    }
  }, [transactions]);
  return (
    <div className='border border-bryt-grey-200 rounded-[12px] flex flex-col overflow-hidden'>
      <div className='bg-bryt-primary-main p-4 flex items-center justify-between'>
        <p className='text-[15px] font-semibold text-white'>
          Latest Transactions
        </p>
        <button className='flex items-center gap-1 px-2 py-[5px] bg-white border border-bryt-grey-200 rounded-[6px] cursor-not-allowed'>
          <img src={ASSETS.sortBy} alt='' />
          <p className='text-xs text-bryt-primary-main'>Sort by</p>
        </button>
      </div>
      <div>
        {txs?.map(transaction => (
          <Transaction
            key={transaction?.unix_timestamp}
            transaction={transaction}
          />
        ))}
      </div>
      <div className='flex items-center justify-center gap-[10px] p-6 border-t border-t-bryt-grey-200 cursor-pointer'>
        <Link to='/transactions'>
          <p className='text-xs font-semibold text-bryt-grey-700 uppercase'>
            View all transactions
          </p>
        </Link>
        <img src={ASSETS.arrowRight} alt='' />
      </div>
    </div>
  );
};

export default Transactions;
